import { GraduationCap, ExternalLink } from "lucide-react";

export default function TalentaCTA({ title, sub, className = "" }) {
  return (
    <a href="https://www.bimbeltalenta.com" target="_blank" rel="noopener noreferrer" data-testid="talenta-cta"
      className={`block clay-card p-5 bg-[#1A1C1A] text-white border-[#1A1C1A] hover:opacity-95 transition-opacity ${className}`}>
      <div className="flex items-center gap-4">
        <span className="h-12 w-12 rounded-xl bg-[#E25E3E] grid place-items-center shrink-0"><GraduationCap className="h-6 w-6" /></span>
        <div className="flex-1 min-w-0">
          <p className="font-heading font-bold text-lg">{title || "Ingin tingkatkan kemampuanmu?"}</p>
          <p className="text-white/70 text-sm">{sub || "Bimbingan belajar, latihan soal & TryOut lebih lengkap bareng mentor di Bimbel Talenta."}</p>
        </div>
        <span className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-[#F4B942] shrink-0">Kunjungi <ExternalLink className="h-4 w-4" /></span>
      </div>
    </a>
  );
}
